import React from "react";
import "../../css/pages/hero.scss";

export const HeroComponent = () => {
  return (
    <div
      className="hero"
      style={{ backgroundImage: "url(/assets/hero-bg-image.avif)" }}
    >
      <div className="heroContent">
        <h2 className="heroTitle">
          مرکز روزانه آموزشی و
          <br /> توانبخشی معلولان جسمی حرکتی ساعی
        </h2>
        <p className="heroDescription">
          ما به شما کمک می‌کنیم تا حرکت را بازیابید و زندگی را دوباره بسازید
        </p>
      </div>
      <div className="heroImage">
        <img src="/assets/hero-bg-shape.svg" alt="Hero Background" />
      </div>
    </div>
  );
};
export default HeroComponent;
